<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" width="800px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3 v-if="get_dialogMain.type == 'create'">Nuevo Role </h3>
                <h3 v-else>Editar Role </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
            <RoleForm :model="role" :on-success="saveRole" :on-cancel="cancel" />
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import RoleForm from '@/components/forms/RoleForm'
export default {
  data: () => ({
    role: {
    }
  }),
  components: {
    RoleForm
  },
  methods: {
    ...mapActions(['postUrlServicesAction']),
    saveRole (model) {
      this.role = model
      this.getUrl('rol.add')
    },
    getUrl (objet) {
      const router = this.get_urls[objet]
      this.postUrlServicesAction({ url: router, data: this.role })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA_MAIN'])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_dialogMain', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Rol agregado.!'
      })
      this.SET_DATA_MAIN(val)
      this.cancel()
    }
  }
}
</script>

<style>

</style>
